module.exports = __webpack_public_path__ + "static/the-art-of-asking-bc17e7358a6a3dbbbbaa05ec28e8be1c.jpg";